'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n'], ['\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: ', ';\n  justify-content: center;\n  align-items: center;\n  margin-left: 10px;\n  animation-name: ', ';\n  animation-timing-function: ', ';\n  animation-iteration-count: infinite;\n  animation-duration: ', ';\n'], ['\n  display: ', ';\n  justify-content: center;\n  align-items: center;\n  margin-left: 10px;\n  animation-name: ', ';\n  animation-timing-function: ', ';\n  animation-iteration-count: infinite;\n  animation-duration: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rotate360 = (0, _styledComponents.keyframes)(_templateObject);

var Spinner = _styledComponents2.default.span(_templateObject2, function (_ref) {
  var animate = _ref.animate;
  return animate ? 'inline-flex' : 'none';
}, rotate360, function (_ref2) {
  var ease = _ref2.ease;
  return ease ? 'ease' : 'linear';
}, function (_ref3) {
  var duration = _ref3.duration;
  return duration || '1s';
});

Spinner.displayName = 'hui:Spinner';
Spinner.huiName = 'Spinner';

exports.default = Spinner;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../spinner/lib/index.js
// module id = 89
// module chunks = 0